import { call, delay, put, race, select, take } from 'redux-saga/effects';

import * as StatsActions from '../../actions';
import * as D from '../../deps';
import * as StatsUtils from '../../utils';

const LOOP = true;
const log = D.Logger.child({ component: 'stats/helpers' });

export function getMusicIdString(searchResults) {
  if (searchResults) {
    const results = Array.from(searchResults);
    const musicIdStr =
      ',' +
      results.map(function (result) {
        return result.id;
      });
    return musicIdStr.substr(1);
  }
  return '';
}

export function* batchEvents() {
  const statsInterval = yield select(D.Utils.TunerVars.getStatsInterval);
  const batchSize = yield select(D.Utils.TunerVars.getStatsBatchSize);

  while (LOOP) {
    const { activity, interval } = yield race({
      activity: take(D.Constants.Analytics.ActionTypes.ADD_EVENT),
      interval: delay(statsInterval),
    });

    const events = yield select(StatsUtils.getEvents);

    // if logging activity detected and we've reached batchSize flush stats queue
    if (activity && events.size >= batchSize) {
      yield call(sendBatchedEventsToServer);
    } else if (interval) {
      // otherwise wait until next interval
      yield call(sendBatchedEventsToServer);
    }
  }
}

export function* sendBatchedEventsToServer(sync = false) {
  const events = yield select(StatsUtils.getEvents);
  if (events.size === 0) {
    return;
  }

  yield put(StatsActions.clearStatsEvents());

  D.Api.makeApiRequest({
    serviceHostType: D.Constants.Api.ServiceHostTypes.STATS,
    schema: D.Schemas.NO_ENTITY,
    endpoint: '',
    method: 'post',
    excludeAuthTokenInHeader: true,
    excludeCsrfTokenInHeader: true,
    sync,
    content: {
      events,
    },
  }).catch(e => {
    log.info(
      {
        obj: e,
      },
      'Stats API call failed',
    );
  });

  // TODO: WEBCLIENT-3545
  // - https://bugs.chromium.org/p/chromium/issues/detail?id=490015
  // - https://github.com/dxa4481/CORS
  // Hey you from the future. When Chrome allows non simple requests (pre flights them properly)
  // then we can look into rewriting the above with a non blocking `sendBeacon`
  // @example
  // const blob = new Blob([JSON.stringify(body)], { 'Content-Type': 'application/json' });
  // navigator.sendBeacon(postApiUrl, blob);
  // const status = navigator.sendBeacon(postApiUrl, JSON.stringify({
  //   events
  // }));
}
